<div class="media-library" [class.media-library--page]="pageMode">
  <div class="ml-toolbar" *ngIf="pageMode || (hasSiteContext() && !siteFilter)">
    <div class="ml-tabs" [class.vl-bulk-tabs]="pageMode" *ngIf="hasSiteContext() && !siteFilter" role="group" [attr.aria-label]="'ml_title' | translate">
      <button type="button" class="ml-tab-btn" [class.vl-bulk-tab]="pageMode" [class.active]="activeTab === 'this'" [class.on]="pageMode && activeTab === 'this'"
        [attr.aria-pressed]="activeTab === 'this'" (click)="onTabChange('this')">
        <i class="bi bi-shop" *ngIf="pageMode" aria-hidden="true"></i>{{ 'ml_tab_this_store' | translate }}
      </button>
      <button type="button" class="ml-tab-btn" [class.vl-bulk-tab]="pageMode" [class.active]="activeTab === 'all'" [class.on]="pageMode && activeTab === 'all'"
        [attr.aria-pressed]="activeTab === 'all'" (click)="onTabChange('all')">
        <i class="bi bi-grid" *ngIf="pageMode" aria-hidden="true"></i>{{ 'ml_tab_all_stores' | translate }}
      </button>
    </div>
    <span class="ml-total" *ngIf="pageMode && !loading && !loadError" aria-live="polite">
      <i class="bi bi-images" aria-hidden="true"></i><strong>{{ totalElements }}</strong> {{ 'ml_total_files' | translate }}
    </span>
  </div>

  <div class="ml-filters" role="search">
    <div class="ml-search">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input type="search" class="form-control form-control-sm" [(ngModel)]="searchValue"
        (ngModelChange)="onSearchInput($event)" [placeholder]="'ml_search_placeholder' | translate"
        [attr.aria-label]="'ml_search_placeholder' | translate">
      <button type="button" class="ml-search__clear" *ngIf="pageMode && searchValue"
        (click)="clearSearch()" [attr.aria-label]="'ml_clear_search' | translate">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>

    <div class="ml-site-filter ml-select" *ngIf="siteFilter && siteOptions.length > 0">
      <select class="form-select form-select-sm" [ngModel]="selectedSiteId"
        (ngModelChange)="onSiteChange($event)" [attr.aria-label]="'ml_site_filter_label' | translate">
        <option value="">{{ 'ml_tab_all_stores' | translate }}</option>
        <option *ngFor="let site of siteOptions" [value]="site.id">{{ site.site_name }}</option>
      </select>
      <i class="bi bi-chevron-down" *ngIf="pageMode" aria-hidden="true"></i>
    </div>

    <div class="ml-type-filter ml-select" *ngIf="!forcedType">
      <select class="form-select form-select-sm" [(ngModel)]="filterType" (change)="onTypeChange(filterType)"
        [attr.aria-label]="'ml_type_filter_label' | translate">
        <option value="">{{ 'ml_type_all' | translate }}</option>
        <option [value]="TypeEnum.PHOTO">{{ 'ml_type_photo' | translate }}</option>
        <option [value]="TypeEnum.VIDEO">{{ 'ml_type_video' | translate }}</option>
        <option [value]="TypeEnum.AUDIO">{{ 'ml_type_audio' | translate }}</option>
        <option [value]="TypeEnum.PDF">{{ 'ml_type_pdf' | translate }}</option>
      </select>
      <i class="bi bi-chevron-down" *ngIf="pageMode" aria-hidden="true"></i>
    </div>

    <span class="ml-total" *ngIf="!pageMode && !loading && totalElements > 0">
      {{ totalElements }} {{ 'ml_total_files' | translate }}
    </span>
    <button type="button" class="ml-refresh" *ngIf="pageMode" (click)="retry()" [disabled]="loading"
      [attr.aria-label]="'ml_refresh' | translate" [title]="'ml_refresh' | translate">
      <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
    </button>
  </div>

  <app-media-library-skeleton *ngIf="loading" [pageMode]="pageMode"></app-media-library-skeleton>

  <ng-container *ngIf="!loading">
    <div class="ml-empty-state ml-empty-state--error" *ngIf="loadError" role="alert">
      <span class="ml-empty-state__icon"><i class="bi bi-cloud-slash" aria-hidden="true"></i></span>
      <h3 class="ml-empty-state__title">{{ 'ml_error_title' | translate }}</h3>
      <p class="ml-empty-state__text">{{ 'ml_error_text' | translate }}</p>
      <button type="button" [ngClass]="pageMode ? 'bo-btn bo-btn--settings bo-btn--soft' : 'btn btn-sm btn-outline-primary mt-2'" (click)="retry()">
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>{{ 'ml_retry' | translate }}
      </button>
    </div>

    <div class="ml-empty-state" *ngIf="!loadError && items.length === 0">
      <span class="ml-empty-state__icon"><i class="bi bi-images" aria-hidden="true"></i></span>
      <h3 class="ml-empty-state__title">{{ (hasActiveFilters() ? 'ml_empty_filtered_title' : 'ml_empty_title') | translate }}</h3>
      <p class="ml-empty-state__text">{{ (hasActiveFilters() ? 'ml_empty_filtered_text' : 'ml_empty_text') | translate }}</p>
      <button type="button" [ngClass]="pageMode ? 'bo-btn bo-btn--settings bo-btn--soft' : 'btn btn-sm btn-outline-primary mt-2'" *ngIf="hasActiveFilters()" (click)="clearFilters()">
        <i class="bi bi-x-circle" aria-hidden="true"></i>{{ 'ml_clear_filters' | translate }}
      </button>
      <button type="button" [ngClass]="pageMode ? 'bo-btn bo-btn--settings bo-btn--primary' : 'btn btn-sm btn-primary mt-2'" *ngIf="selectionMode" (click)="uploadRequested.emit()">
        <i class="bi bi-upload" aria-hidden="true"></i>{{ 'ml_picker_from_device' | translate }}
      </button>
    </div>

    <div class="ml-grid" [class.row]="!pageMode" *ngIf="!loadError && items.length > 0">
      <div [ngClass]="pageMode ? 'ml-grid__item' : 'col-6 col-sm-4 col-md-3 col-xl-2 mb-3'"
        *ngFor="let item of items; let i = index; trackBy: trackByItem">
        <button type="button" class="ml-card" [class.ml-card--selectable]="selectionMode" (click)="onItemClick(item, i)"
          [attr.aria-label]="((selectionMode ? 'ml_select_action' : 'ml_preview_action') | translate) + ': ' + (item.original_filename || item.name || (getTypeLabelKey(item) | translate))">
          <span class="ml-card__thumb">
            <img *ngIf="isImage(item) && item.url && !isBroken(item)" [src]="item.url"
              alt="" loading="lazy" (error)="onImageError(item)">
            <span class="ml-card__placeholder" *ngIf="!isImage(item) || !item.url || isBroken(item)"
              [class.ml-card__placeholder--pdf]="item.type === TypeEnum.PDF"
              [class.ml-card__placeholder--video]="item.type === TypeEnum.VIDEO"
              [class.ml-card__placeholder--audio]="item.type === TypeEnum.AUDIO">
              <i class="bi" [ngClass]="getTypeIcon(item)" aria-hidden="true"></i>
              <span class="ml-card__placeholder-text" *ngIf="isBroken(item)">{{ 'ml_media_unavailable' | translate }}</span>
            </span>
            <span class="ml-card__type-badge"><i class="bi" [ngClass]="getTypeIcon(item)" aria-hidden="true"></i>{{ getTypeLabelKey(item) | translate }}</span>
            <span class="ml-card__open" *ngIf="pageMode && !selectionMode"><i class="bi bi-arrow-up-right" aria-hidden="true"></i></span>
            <span class="ml-card__select-overlay" *ngIf="selectionMode"><i class="bi bi-check-circle-fill" aria-hidden="true"></i></span>
          </span>
          <span class="ml-card__info" [class.ml-card__info--untitled]="pageMode && !item.original_filename && !item.name">
            <span class="ml-card__filename" *ngIf="item.original_filename || item.name"
              [title]="item.original_filename || item.name || (getTypeLabelKey(item) | translate)">
              {{ item.original_filename || item.name || (getTypeLabelKey(item) | translate) }}
            </span>
            <span class="ml-card__meta ml-card__site" *ngIf="siteNameFor(item) as siteName" [title]="siteName">
              <i class="bi bi-shop" aria-hidden="true"></i><span>{{ siteName }}</span>
            </span>
            <span class="ml-card__details">
              <span class="ml-card__meta" *ngIf="formatBytes(item.size_bytes) as size">{{ size }}</span>
              <span class="ml-card__separator" *ngIf="pageMode && item.size_bytes != null && item.created_date" aria-hidden="true">·</span>
              <span class="ml-card__meta" *ngIf="item.created_date">{{ item.created_date | date:'dd/MM/yyyy' }}</span>
            </span>
          </span>
        </button>
      </div>
    </div>

    <div class="ml-pagination" *ngIf="!loadError && totalElements > pageSize">
      <span class="ml-pagination__summary" *ngIf="pageMode">{{ 'ml_results_range' | translate: { start: firstItemNumber, end: lastItemNumber, total: totalElements } }}</span>
      <ngb-pagination [collectionSize]="totalElements" [page]="page + 1" [pageSize]="pageSize"
        [boundaryLinks]="true" [directionLinks]="true" [ellipses]="false" [maxSize]="5" [rotate]="false" size="sm"
        (pageChange)="onPageChange($event)" class="custom-pagination">
      </ngb-pagination>
    </div>
  </ng-container>
</div>
